<div class="toolbar-user" (appClickOutside)="onClickOutside()" fxFlex="grow">
  <button class="button" mat-button (click)="toggleDropdown()" [class.open]="isOpen" fxFlex="grow">
  <span fxLayout="row" fxLayoutAlign="start center">
    <img class="avatar" src="../../../../../assets/img/avatars/guest.png" alt="Avatar">
    <span class="name" fxHide fxShow.gt-sm>{{ account?.name }}</span>
    <mat-icon class="icon" fxHide fxShow.gt-sm>keyboard_arrow_down</mat-icon>
  </span>
</button>

<div class="dropdown" [class.open]="isOpen">
  <div class="content">

    <div class="list">
      <div fxLayout="column" fxLayoutAlign="start start" *ngIf="showId">
        
      </div>
      <div class="list-item" matRipple>
        <mat-icon class="list-item-icon">account_circle</mat-icon>
        <span>Perfil</span>
      </div>
      <div (click)="routeLinkSend('settings')"  class="list-item" matRipple>
        <mat-icon class="list-item-icon">settings</mat-icon>
        <span>Configuración</span>
      </div>
      <div class="list-item" matRipple>
        <mat-icon class="list-item-icon">help</mat-icon>
        <span>Ayuda</span>
      </div>
      <mat-divider></mat-divider>
      <div class="list-item" matRipple (click)="logout()">
        <mat-icon class="list-item-icon">exit_to_app</mat-icon>
        <span>Logout</span>
      </div>
    </div>
  </div>
</div>
</div>
